// -------------------------------------------//
//              Range Slider.
// -------------------------------------------//

angular.module('app.directives.curve_statistic', []).//

directive('curveStatistic', ['$filter','xCenterConfig',
    function ($filter,xCenterConfig) {
        var obj = {
            x: 0,
            startX: 0,
            initValue: 0,
            scope: {
                values: '=values',
                max: '=max',
                min: '=min',
                stepsX: '=stepsx',
                step: '=step',
                delta: '=delta',
                xaxis: '=xaxis',
                yaxis: '=yaxis'
            },
            restrict: 'AE',
            template: '',


            // -------------------------------------------//
            //              Link Function
            // -------------------------------------------//
            link: function (scope, element, attrs, controller) {
                var isTouch = !!('ontouchstart' in window);
                //create canvas and context

                /*	scope.$watch('values',function(newvalue){
                 //console.log(scope.values);
                 //scope.draw();
                 },true)*/
                scope.$on('curve_update', function (event, data) {
                    //console.log(data);
                    scope.draw(data.xAxis, data.yAxis, data.values);
                });
                var canvas = document.createElement('canvas');
                canvas.id = 'curveCanvas';
                //canvas.id = options.canvasId;
                scope.units = 10;
                scope.fineUnits = 10;
                scope.gridColorReg = '#999999';
                scope.gridColorFine = '#333333';
                scope.withFineGrid = true;
                // Radius for Circles
                scope.radius = 5;


                canvas.width = 800;
                canvas.height = 480;
                scope.topBottomPixel = canvas.height * xCenterConfig.statistic_delta_percent;

                element.append(canvas);
                var ctx = canvas.getContext('2d');
                scope.offsetY = -5;
                scope.offsetX = 5;
                scope.offsetYGraph = 0;

                scope.draw = function (xa, ya, va) {
                    if (xa != undefined) {
                        scope.xaxis = xa;
                    }
                    if (ya != undefined) {

                        scope.yaxis = ya;
                    }
                    if (va != undefined) {

                        scope.values = va;
                    }



                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.moveTo(0, 0);

                    scope.drawLines();
                   // console.log('Values', scope.values);
                    if (scope.values && scope.values.length > 0) {

                        ctx.mozImageSmoothingEnabled = false;

                        ctx.lineJoin = 'round';
                        ctx.lineCap = 'round';
                        ctx.shadowBlur = 1;


                        scope.values.walk(function (o2, i2) {
                            ctx.shadowColor = o2.$color;
                            //console.log(o2);
                            ctx.strokeStyle = o2.$color;
                            o2 = $filter('orderBy')(o2, '+TimeStampUtc');
                            var first;
                            var lastY = 0;
                            //console.log(o2.$color);
                            //
                            o2.walk(function (o, i) {
                                //console.log(o.Value.Value);

                                var x = o.Value.x + scope.offsetX;
                                var y;
                                if (o.Value.Value != 'NaN') {

                                    ctx.lineWidth = 2;

                                    y = (canvas.height - o.Value.y);

                                    if ((first === undefined && y != NaN) || lastY == false) {
                                        ctx.beginPath();
                                        ctx.moveTo(x, y);
                                        first = false;
                                    }


                                    ctx.lineTo(x, y);
                                    ctx.stroke();
                                    lastY = y;
                                   // console.log('---Draw');
                                } else {
                                    if (o2[i - 1] !== undefined && o2[i - 1].Value.Value != 'NaN') {
                                        y = (canvas.height - o2[i - 1].Value.y);
                                        x = (o2[i - 1].Value.x + scope.offsetX);
                                        ctx.moveTo(x, y);
                                    } else {
                                        y = false;
                                        ctx.moveTo(x, 0);
                                    }
                                  //  console.log('---DrawnoNan');
                                    lastY = y;

                                }
                            });
                        });

                    }
                    //}


                };

                scope.drawLines = function () {
                    ctx.shadowBlur = 0;
                    ctx.mozImageSmoothingEnabled = false;
                    //

                    ctx.lineJoin = 'round';



                    if (scope.yaxis) {
                        //console.log(scope.yaxis);
                        if(!scope.yaxis[0] || !scope.yaxis[1] || !scope.yaxis[1].y || !scope.yaxis[0].y){
                            return;
                        }
                        var pXValOneStep = Math.abs(scope.yaxis[1].y - scope.yaxis[0].y);
                        for (var i = 0; i < scope.yaxis.length; i++) {
                            var y = (canvas.height - scope.yaxis[i].y );
                           // console.log('painting to y' + y);
                            ctx.beginPath();
                            ctx.lineWidth = 0.5;
                            ctx.strokeStyle = scope.gridColorReg;
                            ctx.moveTo(0, y);
                            ctx.lineTo(canvas.width, y);
                            ctx.stroke();

                            //if(i > 0){ m = i-1;}else{m = i + 1};

                            if (scope.withFineGrid) {
                                for (var j = 0; j < (scope.fineUnits - 1); j++) {
                                    ctx.beginPath();
                                    var y2 = ( y - ( ( (j + 1 ) / scope.fineUnits ) * pXValOneStep  ) );
                                    ctx.lineWidth = 0.3;
                                    ctx.strokeStyle = scope.gridColorFine;
                                    ctx.moveTo(0, y2);
                                    ctx.lineTo(canvas.width, y2);
                                    ctx.stroke();
                                }

                            }

                        }
                    }


                    //Last Line at the bottom
                    ctx.beginPath();
                    ctx.strokeStyle = scope.gridColorReg;
                    ctx.moveTo(0, canvas.height - 1);
                    ctx.lineTo(canvas.width, canvas.height - 1);
                    ctx.stroke();



                    if (scope.xaxis) {
                        for (var i = 0; i < scope.xaxis.length; i++) {
                            ctx.beginPath();
                            var x = (canvas.width - scope.offsetX ) * ( scope.xaxis[i].Percent / 100 );
                            ctx.lineWidth = 0.3;
                            ctx.strokeStyle = scope.gridColorReg;

                            ctx.moveTo(x, 0);
                            ctx.lineTo(x, canvas.height);
                            ctx.stroke();
                        }
                    }

                };

            }

        };
        return obj;


    }]);
